// Imports
import React from 'react';
// Contents
import Link from "../menu-link/LinkHelper";
import { l } from '../../lang/index.jsx';

export default function PageHero({data, navigate, lang, uiMap }) {

    const button = uiMap?.['back-button']?.[lang] || l('back-button', lang);
    const visit = uiMap?.['visit-website']?.[lang] || l('visit-website', lang);

    return (
        <div className='section section-page-hero'>
            <div className='page-hero single-project'>
                <div className='page-hero-content singleProject'>
                    <div className='page-hero-back'>
                        <Link navigate={navigate} className='button back-button' href={'/' + 'projects'} aria-label="Back to projects list">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                            </svg>
                            <span>{button}</span>
                        </Link>
                    </div>

                    <h1 className='h1 single-title'>{data.title}</h1>
                    
                    <div className='project-infos'>
                        <div className='project-infos-inner'>
                            {data.date && (
                                // Utilise le sprite SVG pour afficher l'icône via <use>
                                <p className="project-date">
                                    <svg className="icon date-icon" width="20" height="20" aria-hidden="true" focusable="false">
                                        <use href="/icons.svg#icon-date" />
                                    </svg>
                                    <span className="date-text">{data.date}</span>
                                </p>
                                // <span className='info-title'>Date: </span>
                            )}
                            {data.agency && (
                                <p className="project-agency font-bold">
                                    <svg className="icon company-icon" width="20" height="20" aria-hidden="true" focusable="false">
                                        <use href="/icons.svg#icon-company" />
                                    </svg>
                                    <span className="agency-text">{data.agency}</span>
                                </p>
                                // <span className='info-title'>Client: </span>
                            )}
                            {data.info && (
                                <p className="project-info">
                                    <svg className="icon dev-icon" width="20" height="20" aria-hidden="true" focusable="false">
                                        <use href="/icons.svg#icon-development" />
                                    </svg>
                                    <span className="info-text">{data.info}</span>
                                </p>
                                // className="info-project"
                            )}
                        </div>
                        <div>
                            {data.url && (
                                <a target="_blank" rel="noopener noreferrer" className='button' href={data.url} aria-label={data?.title ? `See the website ${data.title}` : 'See the website'}>
                                    <span>{visit}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                                    </svg>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}